<template>
    <v-form>
        <v-card flat class="fill-height">
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12>
                        <provider-title title="Mi Firma"/>
                    </v-flex>

                    <v-flex xs12 class="mt-3">
                        <signature-picker
                            :max-size="2"
                            height="120"
                            :rounded="true"
                            img-label="Seleccionar firma"
                            @change="signature_file = $event; deleteSignatureFile = false"
                            @delete="deleteSignatureFile = $event"
                            :default="signature_image"
                        />
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveSignature" :loading="saving">
                    guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import {ApiUtils} from '@/utils/ApiUtils'
import {mapState} from 'vuex'
import ProviderTitle from "@/components/providers/panel/ProviderTitle";
import SignaturePicker from "@/components/common/SignaturePicker";

export default {
    components: {SignaturePicker, ProviderTitle},
    data() {
        return {
            saving: false,
            signature_image: null,
            signature_file: null,
            deleteSignatureFile: false,
        }
    },
    computed: {
        ...mapState(['currentProvider']),
    },
    mounted() {
        this.setDefault()
    },
    methods: {
        async saveSignature() {
            const vm = this
            if (vm.saving || !vm.currentProvider) return
            vm.saving = true

            let payload = {
                signature: vm.signature_file,
                delete_signature: vm.deleteSignatureFile ? 1 : 0
            }

            const response = await ApiUtils.makePatch(`specialist/${vm.currentUser.id}/signature`, null, payload)
            if (!response.ok) {
                vm.toast('Ha ocurrido un error guardando la firma', 'error')
            } else {
                vm.toast(vm.deleteSignatureFile ? 'Firma eliminada' : 'Firma guardada correctamente')
            }

            vm.saving = false
            await ApiUtils.fetchMe()
        },
        async setDefault() {
            const vm = this
            vm.signature_image = vm.currentUser.signature_image
        }
    },
}
</script>